// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mw-0";
export var fileList = "_mw-2";
export var removeFileButton = "_mw-1";